module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAP5JREFUOE+tkz1KQ0EUhb/zhIBFFqGVJIIiprG2MPvQwp/C+FxAFuBLtIiN2YZgIVmACaJg1ErcQ0TNg7wbklF5RAQzL9PNmXs+7sycKybXbVjA2MYoAwvuWC/IrhBN1qLHtEU/m241x3uvhtgFgl9gJyRIF/QHFTbqH2P0WB6ZP3uXGJt/GCflFvP5MsVq7ACdsAHs/dPsyowGpehA3FSKBME9MDcVAAYkyYpoH9WRDqc0f3Vhp6ITPgFLXgB4HgH6QM4TEGcFvGW9QjfbI8KZaB8vI7vz+kbTqn+Q4Jz1aH9GUf6eB+9hSofARXsH2AIWgRh4Ba4xNSmdPKTLh6LTXRCTzF0+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/dot.png
// module id = f6T9
// module chunks = 1